<template>
  <div class="dropdown-container">

    
    <!-- Верхняя стрелка -->
    <div v-if="showTopArrow" class="scroll-indicator top-arrow">
      <span>↑</span>
    </div>
    
    <a-menu 
      ref="menuRef" 
      class="scrollable-dropdown-menu" 
      @scroll="handleScroll"
    >
      <a-menu-item v-for="player in availablePlayers" :key="player.id" @click="assignPlayer(player)">
        <a-avatar :src="player.photo_url" shape="circle" :size="32" />
        <b :style="{ padding: '0px 2px 0px 6px' }">{{ player.number }}</b> {{ player.last_name }} {{ player.first_name }}
      </a-menu-item>
      <a-menu-item v-if="availablePlayers.length === 0" disabled>
        Нет доступных игроков
      </a-menu-item>
    </a-menu>
    
    <!-- Нижняя стрелка -->
    <div v-if="showBottomArrow" class="scroll-indicator bottom-arrow">
      <span>↓</span>
    </div>
  </div>
</template>

<script>
import { ref, computed, nextTick, watch, onMounted } from 'vue';

export default {
  name: 'ScrollableDropdown',
  props: {
    availablePlayers: {
      type: Array,
      required: true,
    },
    fieldId: {
      type: Number,
      required: true,
    },
    onPlayerSelect: {
      type: Function,
      default: null,
    },
  },
  emits: ['player-assign'],
  setup(props, { emit }) {
    const menuRef = ref(null);
    const showTopArrow = ref(false);
    const showBottomArrow = ref(false);

    const handleScroll = () => {
      updateArrowVisibility();
    };

    const updateArrowVisibility = () => {
      if (!menuRef.value) return;

      const menu = menuRef.value.$el;
      const scrollTop = menu.scrollTop;
      const scrollHeight = menu.scrollHeight;
      const clientHeight = menu.clientHeight;

      // Проверяем, есть ли вообще скролл
      const hasScroll = scrollHeight > clientHeight;

      if (hasScroll) {
        // Показываем верхнюю стрелку, если есть контент выше
        showTopArrow.value = scrollTop > 10;

        // Показываем нижнюю стрелку, если есть контент ниже
        showBottomArrow.value = scrollTop + clientHeight < scrollHeight - 10;
      } else {
        // Если скролла нет, скрываем обе стрелки
        showTopArrow.value = false;
        showBottomArrow.value = false;
      }


    };

    const assignPlayer = (player) => {
      console.log('Player selected:', player);
      if (props.onPlayerSelect) {
        props.onPlayerSelect(player);
      } else {
        emit('player-assign', props.fieldId, player.id);
      }
    };

    // Инициализация при монтировании
    onMounted(() => {
      nextTick(() => {
        setTimeout(() => {
          updateArrowVisibility();
        }, 100);
      });
    });

    // Следим за изменениями в списке игроков
    watch(() => props.availablePlayers, () => {
      nextTick(() => {
        updateArrowVisibility();
      });
    });

    return {
      menuRef,
      showTopArrow,
      showBottomArrow,
      handleScroll,
      assignPlayer,
    };
  },
};
</script>

<style scoped>
.dropdown-container {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.scrollable-dropdown-menu {
  max-height: 300px !important;
  overflow-y: auto !important;
  border-radius: 8px !important;
}

/* Индикаторы скролла */
.scroll-indicator {
  position: absolute;
  left: 0;
  right: 0;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  pointer-events: none;
  z-index: 10;
  transition: opacity 0.2s ease;
}

.scroll-indicator.top-arrow {
  top: 0;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px 8px 0 0;
  backdrop-filter: blur(2px);
}

.scroll-indicator.bottom-arrow {
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 0 0 8px 8px;
  backdrop-filter: blur(2px);
}

/* Темная тема */
@media (prefers-color-scheme: dark) {
  .scroll-indicator {
    color: #fff;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);
  }
  
  .scroll-indicator.top-arrow {
    background: rgba(31, 31, 31, 0.3);
    backdrop-filter: blur(2px);
  }
  
  .scroll-indicator.bottom-arrow {
    background: rgba(31, 31, 31, 0.3);
    backdrop-filter: blur(2px);
  }
}

/* Мобильные устройства */
@media (max-width: 768px) {
  .scrollable-dropdown-menu {
    max-height: 350px !important;
  }
  
  .scroll-indicator {
    height: 16px;
    font-size: 10px;
  }
}
</style> 